module.exports = __webpack_public_path__ + "img/icon-gongan.448b2291.png";